// extracted by mini-css-extract-plugin
module.exports = {"flexCardListItem":"Card_flexCardListItem__khSI4","flexCard":"Card_flexCard__1o6wJ"};